import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { PriceBreakuptype } from '../types/model';
import { getHeaders } from '../utils/headers';

function serializePriceBreakdown(response) {
  let data = response?.data;
  if(response?.data?.length){
    data = response?.data?.[0];
  }
  const result: PriceBreakuptype = {
    variantId: data?.variant_id || null,
    cityId: data?.locale_id || null,
    emi: data?.emi?.title || data?.emi?.emi || 'N/A',
    insurance: data?.insurance,
    exShowRoomPrice: data?.ex_showroom_price,
    rto: data?.rto,
    otherCharges: data?.other,
    onRoadPrice: data?.on_road_price_slug || data?.on_road_price || 'N/A',
    cityName: data?.locale_name || 'N/A'
  };
  return result;
}

const fetchPriceBreakdown = async ({ locationSlug, variantId }) => {
  const url = `${apiConfig(
    'chariot'
  )}/v1/variant/locale?variant_id=${variantId}&locale_id=${locationSlug}`;
  const { response, error }: any = await getMethod({ endPoint: url,    headers: getHeaders() });
  if (response) {
    return  {response: serializePriceBreakdown(response)} ;
  } else return { error: null };
};
export default fetchPriceBreakdown;
